import React, { FC, useEffect, useState } from 'react';

import { IBlock } from '../../../types/content';
import { ISBPost } from '../../../types/thirdPartyContent';
import PostPreview from './PostPreview';
import imageSources from '../../../constants/imageSources/imageSources';
import * as Styled from './styles';

interface IProps {
    posts: ISBPost[];
    block: IBlock;
    currentLanguage: string;
    loadingPosts: boolean;
}

const List: FC<IProps> = ({ posts, block, currentLanguage, loadingPosts }) => {
    const [visiblePosts, setVisiblePosts] = useState(posts);

    useEffect(() => {
        setVisiblePosts(posts);
    }, [posts]);

    // do not show loader when lazy loading
    if (loadingPosts && posts.length === 0) {
        return (
            <Styled.LoadingWrapper postsLength={posts.length}>
                <img src={imageSources.CONTENT_LIBRARY_LOADER} alt="Loading" width="110" />
            </Styled.LoadingWrapper>
        );
    }

    return (
        <div>
            {visiblePosts.length > 0 ? (
                visiblePosts.map((post) => (
                    <PostPreview
                        data-test-id={post.id}
                        key={post.id}
                        post={post}
                        block={block}
                        currentLanguage={currentLanguage}
                    />
                ))
            ) : (
                <div style={{ textAlign: 'center' }}>
                    <img src={imageSources.STAFFBASE.NO_RESULTS} alt="" />
                    <Styled.Text>We couldn’t find any news posts with this title.</Styled.Text>
                </div>
            )}
        </div>
    );
};

export default List;
